import Service from 'core/service'

export class SettingService extends Service {
  getAllSettings(): Promise<SettingModel[]> {
    return this.get('/settings')
  }
  createOrUpdateSetting(params: object): Promise<SettingModel[]> {
    return this.post('/settings', params)
  }
}
